// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1cilt","content":"RecentSearches_content__SIgCY"};